import type { PassportApplication } from '@unanet/unafy';
/**
 * Interfaces
 */
export interface AppLauncherComponentProps {
  apps?: string;
  issuer?: string;
  sandbox?: string | boolean;
  userKey?: string | number;
}
/**
 * END: Interfaces
 */

/**
 * Defaults
 */
export const experienceCenterApp: PassportApplication = {
  Application: 'webapp',
  CustomerIdentifier: '',
  Description: 'Help, support, training, and more',
  DisplayName: 'Experience Center',
  GroupName: '',
  InstanceType: 'prod',
  Path: 'https://experiencecenter.unanet.com/',
  Product: 'experience-center',
} as const;

/**
 * END: Defaults
 */
